module.exports = __webpack_public_path__ + "img/1F1F8-1F1E7.25171f38.svg";